import React from "react";
import { BannerContainer, BannerContent, BannerDescription, BannerImage, BannerShopButton, BannerTitle, BannerVideo } from "../../styles/banner";
import { Typography } from "@mui/material";
import useDialogModel from "../../hooks/useDialogModel";
import { AllProducts } from "../allProducts";
import videoBg from "../../assets/video2.mp4";


export default function Banner ({product}) {
    
    const[AllProductDialog, showAllProductDialog]
    =useDialogModel(AllProducts, {product})

    return (
        <>
        <BannerContainer>
            <BannerVideo src={videoBg} autoPlay loop muted controls></BannerVideo>
            <BannerContent>
                <Typography variant= "h6">We pioneer breakthroughs in healthcare.</Typography>
                <BannerTitle variant= "h2">For everyone. Everywhere.</BannerTitle>
                <BannerShopButton color= "secondary" onClick={()=> showAllProductDialog()}>ALL SERVICES</BannerShopButton>
            </BannerContent>
        </BannerContainer>
        <AllProductDialog product={product}/>
        </>
    )
}